import * as React from "react";

function SvgLogo(props) {
  return (
    <svg
      id="logo_svg__\u30EC\u30A4\u30E4\u30FC_1"
      data-name="\u30EC\u30A4\u30E4\u30FC 1"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...props}
    >
      <defs>
        <style>{".logo_svg__cls-3{fill:#fff}"}</style>
      </defs>
      <rect x={1} y={1} width={26} height={26} rx={2.48} fill="#34adf7" />
      <rect x={4} y={4} width={27} height={27} rx={2.25} fill="#0063ac" />
      <path className="logo_svg__cls-3" d="M4 4h5v23H4zM22 4h5v23h-5z" />
      <path className="logo_svg__cls-3" d="M9 4l18 23h-5L4 4h5z" />
    </svg>
  );
}

export default SvgLogo;

